import React, { useState } from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, IconButton,
} from '@mui/material';

import {
  Delete as DeleteIcon,
} from '@mui/icons-material';

import PropTypes from 'prop-types';
import localization from '../../../localization';

import '../../TableComponent/TableComponent.scss';
import { TABLE_SCOPE } from '../../../services/constants';

const DeletePopup = ({
  selectedItems,
  deleteFunc,
  deleteIcon,
  checkedItem,
}) => {
  const [open, setOpen] = useState(false);

  const isStoreList = window.location.pathname.includes(TABLE_SCOPE.STORES);
  const isCurrenciesPage = window.location.pathname.includes(TABLE_SCOPE.CURRENCIES);
  const isLocalesPage = window.location.pathname.includes(TABLE_SCOPE.LOCALES);
  const isCountriesPage = window.location.pathname.includes(TABLE_SCOPE.COUNTRIES);
  const isSubsidiariesPage = window.location.pathname.includes(TABLE_SCOPE.SUBSIDIARIES);
  const isEndUserPage = window.location.pathname.includes(TABLE_SCOPE.END_USER_LIST);

  const isProductOnly = !isStoreList &&
    !isCurrenciesPage && !isLocalesPage && !isCountriesPage && !isSubsidiariesPage && !isEndUserPage;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {
        deleteIcon ? (
          <IconButton
            color="secondary"
            onClick={handleClickOpen}
          >
            {deleteIcon}
          </IconButton>
        ) : <DeleteIcon className="deleteIcon icons" onClick={handleClickOpen} />
      }

      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogContent>
          <DialogContentText color="inherit">
            {isStoreList && (checkedItem ? (
              localization.t('labels.areYouSureYouWantToDeleteTheStores')
            ) : (
              localization.t('labels.areYouSureYouWantToDeleteTheStore')
            ))}

            {isCurrenciesPage && (checkedItem ? (
              localization.t('labels.areYouSureYouWantToDeleteTheCurrencies')
            ) : (
              localization.t('labels.areYouSureYouWantToDeleteTheCurrencie')
            ))}

            {isLocalesPage && (checkedItem ? (
              localization.t('labels.areYouSureYouWantToDeleteTheLocales')
            ) : (
              localization.t('labels.areYouSureYouWantToDeleteTheLocale')
            ))}

            {isCountriesPage && (checkedItem ? (
              localization.t('labels.areYouSureYouWantToDeleteTheCountries')
            ) : (
              localization.t('labels.areYouSureYouWantToDeleteTheCountry')
            ))}

            {isSubsidiariesPage && (checkedItem ? (
              localization.t('labels.areYouSureYouWantToDeleteTheSubsidiaries')
            ) : (
              localization.t('labels.areYouSureYouWantToDeleteTheSubsidiary')
            ))}

            {isEndUserPage && (checkedItem ? (
              localization.t('labels.areYouSureYouWantToDeleteThePaymentMethods')
            ) : (
              localization.t('labels.areYouSureYouWantToDeleteThePaymentMethod')
            ))}

            {isProductOnly && (checkedItem ? (
              localization.t('labels.areYouSureYouWantToDeleteTheProducts')
            ) : (
              localization.t('labels.areYouSureYouWantToDeleteTheProduct')
            ))}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {localization.t('labels.cancel')}
          </Button>
          <Button onClick={() => { handleClose(); deleteFunc(selectedItems); }} color="primary">
            {localization.t('labels.confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

DeletePopup.propTypes = {
  selectedItems: PropTypes.array,
  deleteFunc: PropTypes.func,
  deleteIcon: PropTypes.any,
  checkedItem: PropTypes.bool,
};

export default DeletePopup;
